import styled, { x } from "@xstyled/styled-components"

const Flex = styled(x.div)`
  display: flex;
`

export default Flex
